export default __webpack_public_path__ + "static/lframe-solar-loan-2c845b3e187924998a787cd829e6120c.webp";